module.exports = "https://static.wmbcdn.com/uniweb/images/0e00ed2068664b741aaed227d1feb1af.svg";